import { render, staticRenderFns } from "./CarouselList.vue?vue&type=template&id=da056614&scoped=true"
import script from "./CarouselList.vue?vue&type=script&lang=js"
export * from "./CarouselList.vue?vue&type=script&lang=js"
import style0 from "./CarouselList.vue?vue&type=style&index=0&id=da056614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da056614",
  null
  
)

export default component.exports